import React from "react";
import { blogs } from "../mock";
import { ArrowRight } from "lucide-react";
import useReveal from "../hooks/useReveal";

export default function Blogs() {
  const ref = useReveal();
  return (
    <section className="bg-white py-16">
      <div ref={ref} className="reveal mx-auto max-w-7xl px-4 lg:px-8">
        <div className="mb-8 text-center">
          <h2 className="font-heading text-2xl font-extrabold text-navy md:text-3xl">
            Guides & Inspiration
          </h2>
          <p className="mt-2 text-sm text-navy/60">
            Expert advice to help you buy smart and train harder.
          </p>
        </div>
        <div className="grid gap-6 md:grid-cols-3">
          {blogs.map((b) => (
            <a
              key={b.id}
              href="#"
              className="group flex flex-col overflow-hidden rounded-2xl border border-navy/10 bg-white shadow-sm transition-all hover:-translate-y-1 hover:shadow-xl"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={b.image}
                  alt={b.title}
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <span className="absolute left-3 top-3 rounded-full bg-brand px-3 py-1 text-[11px] font-bold uppercase tracking-wide text-white">
                  {b.category}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-lg font-bold leading-snug text-navy">{b.title}</h3>
                <span className="mt-4 inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wide text-brand transition-all group-hover:gap-2.5">
                  Read Article <ArrowRight size={14} />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
